module.exports = __webpack_public_path__ + "static/img/058_TO8_1607_og.8d863f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/058_TO8_1607_og.jpg
// module id = sK6h
// module chunks = 0